import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { deleteActions, getActions } from "../../network/api/actions";

const ViewActionsPage = () => {
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("super"));
  const [actionsSelected, setActionsSelected] = useState([]);
  const [actions, setActions] = useState(null);
  const [pageCount, setPageCount] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [showDelete, setShowDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(
    Number(cookie.get("actions_page")) || 1,
  );

  const handleSelect = (id) => {
    if (actionsSelected.includes(id)) {
      setActionsSelected(actionsSelected.filter((item) => item !== id));
    } else {
      setActionsSelected([...actionsSelected, id]);
    }
  };

  const actionsGet = async () => {
    try {
      setActions(null);
      const result = await getActions(currentPage);

      setActions(result.data.actions);
      setPageCount(result.data.pageCount);
      setTotalCount(result.data.totalCount);
    } catch {
      toast.error("Failed to load actions");
      setActions([]);
    }
  };

  useEffect(() => {
    actionsGet();
  }, [currentPage]);

  const handlePageClick = (page) => {
    setCurrentPage(page);
    cookie.set("actions_page", page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      cookie.set("actions_page", currentPage - 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleNext = () => {
    if (currentPage < pageCount) {
      setCurrentPage(currentPage + 1);
      cookie.set("actions_page", currentPage + 1);
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const renderPageNumbers = () => {
    let pages = [];

    if (pageCount <= 10) {
      // Show all pages if less than 10
      for (let i = 1; i <= pageCount; i++) {
        pages.push(i);
      }
    } else {
      // Always show 1-10
      if (currentPage <= 10) {
        for (let i = 1; i <= 10; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount);
      } else {
        // After page 10, show current - 2 to current + 2
        pages.push(1);
        pages.push("...");
        let start = Math.max(currentPage - 2, 2);
        let end = Math.min(currentPage + 2, pageCount - 1);

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }

        if (end < pageCount - 1) {
          pages.push("...");
        }
        pages.push(pageCount);
      }
    }

    return pages.map((page, index) =>
      page === "..." ? (
        <span key={index} className="px-2">
          ...
        </span>
      ) : (
        <button
          key={index}
          onClick={() => handlePageClick(page)}
          className={
            currentPage === page ? "paginationButtonActive" : "paginationButton"
          }
        >
          {page}
        </button>
      ),
    );
  };

  const handleDelete = () => {
    deleteActions({ actions: actionsSelected }).then((result) => {
      if (result.data.message === "Actions deleted successfully") {
        setActionsSelected([]);
        setShowDelete(false);
        handlePageClick(1);
        toast.success(result.data.message, {
          position: "top-right",
        });
        actionsGet();
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
    });
  };

  return (
    <>
      {actions === null ? (
        <LoadingPage />
      ) : (
        <div className="channel-page">
          {/* HEADER */}
          <div className="page-header">
            <h2>Actions</h2>
            <span>{totalCount || 0} Actions</span>
            {actionsSelected.length > 0 && (
              <>
                {isSuper && (
                  <button
                    className="assignbtn"
                    onClick={() => {
                      setShowDelete(true);
                    }}
                  >
                    Delete {actionsSelected.length} Actions
                  </button>
                )}
              </>
            )}
          </div>

          {/* DESKTOP TABLE */}
          <div className="table-scroll">
            <div className="table-container">
              <table className="modern-table">
                <thead>
                  <tr>
                    {isSuper && <th>Select</th>}
                    <th>Name</th>
                    <th>Type</th>
                    <th>Date</th>
                  </tr>
                </thead>

                <tbody>
                  {actions?.map((item) => (
                    <tr key={item._id}>
                      {isSuper && (
                        <td>
                          <input
                            id="check"
                            type="checkbox"
                            checked={actionsSelected.includes(item?._id)}
                            onChange={() => {
                              handleSelect(item._id);
                            }}
                          />
                        </td>
                      )}
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      <td>{new Date(item.createdAt).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* MOBILE CARDS */}
          <div className="cards-container">
            {actions?.map((item) => (
              <div className="channel-card" key={item._id}>
                <div className="card-title">{item.name}</div>
                <div className="card-date">
                  {new Date(item.createdAt).toLocaleDateString()}
                </div>
              </div>
            ))}
          </div>

          <div
            className="mt-4"
            style={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              padding: "10px",
            }}
          >
            {currentPage !== 1 && (
              <button
                onClick={handlePrevious}
                disabled={currentPage === 1}
                className="paginationButton"
              >
                Previous
              </button>
            )}
            {renderPageNumbers()}
            {currentPage !== pageCount && pageCount > 0 && (
              <button
                onClick={handleNext}
                disabled={currentPage === pageCount}
                className="paginationButton"
              >
                Next
              </button>
            )}
          </div>
        </div>
      )}

      {showDelete && (
        <div className="popup-overlay">
          <div
            className="popup-box popup-animation"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="popup-header">
              <h2>Delete actions</h2>
              <button
                className="close-btn"
                onClick={() => setShowDelete(false)}
              >
                ✕
              </button>
            </div>

            <div className="show-lead row gap-3">
              <div className="item-edit d-flex col-5 align-items-center">
                <p>You want to delete this actions?</p>
              </div>
            </div>
            <div className="popup-actions">
              <button
                className="cancel-btn"
                onClick={() => setShowDelete(false)}
              >
                No
              </button>

              <button className="confirm-btn" onClick={handleDelete}>
                Yes
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default ViewActionsPage;
